import Diamond from "./SVG/diamond.svg?react";

const DiamondIcon = () => {
  return <Diamond />;
};

export default DiamondIcon;
